import { useMutation, useQueryClient } from 'react-query';

import type { TVendorCodesInternetHomeWarranty } from './../../../models/vendor/VendorCodeModels';
import type { TCreateModel } from '../../../utils/hookUtils';
import QUERYKEYS from '../../../constants/queryKeys';
import { createVendorCodeInternetHomeWarranty } from './../../../services/VendorCodesService';

const useCreateVendorCodeInternetHomeWarranty =
  (): TCreateModel<TVendorCodesInternetHomeWarranty> => {
    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation(createVendorCodeInternetHomeWarranty, {
      onSuccess: () =>
        queryClient.invalidateQueries({
          predicate: (query) =>
            query.queryKey === QUERYKEYS.VENDOR_CODES || query.queryKey[0] === QUERYKEYS.VENDORS,
        }),
    });

    return {
      create: mutate,
      isLoading,
    };
  };

export default useCreateVendorCodeInternetHomeWarranty;
